//@ts-nocheck
import React, { useEffect, useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button } from 'rizzui';
import { toast } from 'sonner';

interface SignatureBoxProps {
  onSignatureComplete: (signatureBase64: any) => void;
  signatureRef?: React.RefObject<SignatureCanvas>;
}

const SignatureBox: React.FC<SignatureBoxProps> = ({ onSignatureComplete, signatureRef }) => {


  const handleClear = () => {
    if (signatureRef?.current) {
        signatureRef.current.clear();
        
    }
    onSignatureComplete('');
  };

  const handleSave = () => {
    if (signatureRef?.current?.isEmpty()) {
      toast.error('Por favor, realice su firma antes de guardar.');
      return;
    }
    const signatureBase64 = signatureRef?.current?.toDataURL();
    onSignatureComplete(signatureBase64); 
  };

  return (
    <div className="border border-gray-300 rounded-md p-4">
      {/* Canvas para la firma */}
      <SignatureCanvas
        key="signatureCanvas"
        ref={signatureRef}
        canvasProps={{
          width: 550,
          height: 200,
          className: 'signature-canvas',
        }}
      />
      {/* Botones de acción */}
       <div className="mt-4 flex justify-between">
       <Button type="button" onClick={handleClear} variant="outline">
         Limpiar
       </Button>
       <Button type="submit" onClick={handleSave}>
          Guardar Firma
        </Button>
      </div> 
    </div>
  );
};

export default SignatureBox;
